import { Lightbulb, Brain, Sparkles, Video, MapPin, BellRing, Apple, Smartphone, Monitor } from "lucide-react";

export const FEATURES = [
  { id: "cognitive", icon: Brain, num: "01" },
  { id: "routing", icon: Sparkles, num: "02" },
  { id: "empathy", icon: Lightbulb, num: "03" },
  { id: "video", icon: Video, num: "04" },
  { id: "place", icon: MapPin, num: "05" },
  { id: "notify", icon: BellRing, num: "06" },
];

export const PLANS = [
  { key: "free", name: "Free", price: "€0", periodKey: "forever", lookup_key: null, highlight: false, featureCount: 4 },
  { key: "pro", name: "Pro", price: "€9.99", periodKey: "perMonth", lookup_key: "rexx_pro_monthly", highlight: true, featureCount: 6 },
  { key: "enterprise", name: "Enterprise", price: "€29.99", periodKey: "perMonth", lookup_key: "rexx_enterprise_monthly", highlight: false, featureCount: 6 },
];

export const DOWNLOAD_PLATFORMS = [
  { id: "apple", icon: Apple },
  { id: "android", icon: Smartphone },
  { id: "windows", icon: Monitor },
];

export const FOOTER_LINKS = [
  { label: "Nexxaris", href: "https://www.nexxaris.com" },
  { label: "Rating Online", href: "https://www.ratingonline.store" },
  { label: "Certytrace", href: "https://www.certytrace.store" },
];

export const REXXPONS_URL = "https://www.rexxxponsnetwork.online";

export const LAW_FIRM = {
  name: "Galano & Partners Law Firm",
  address: "Piazza Malta 21, Salerno, Italy",
  email: "avv.luigigalano@pec.it",
  whatsapp: "+39 340 959 2059",
  whatsappLink: "https://wa.me/393409592059",
};

export const NETWORK_APPS = [
  { label: "Galano Risk System", href: "https://ratingonline.store" },
  { label: "Business Plan", href: "https://businessplan.ratingonline.store" },
  { label: "Due Diligence Hub", href: "https://certytrace.store" },
  { label: "Due Diligence", href: "https://reputazione.shop" },
  { label: "Rexx Calling", href: "https://rexxcalling.com" },
  { label: "Empathy Sync", href: "https://rexxcalling.shop" },
  { label: "Nexxaris", href: "https://nexxaris.com" },
  { label: "Rexxind", href: "https://rexxind-preview.emergentagent.com" },
  { label: "Diritto Smart", href: "https://diritto-smart.emergentagent.com" },
  { label: "Counsel AI", href: "https://counsel-ai-platform-1.emergentagent.com" },
];

export const DOWNLOAD_URL = "https://empathy-sync.emergentagent.com";
export const APP_MOCKUP = "https://static.prod-images.emergentagent.com/jobs/88abf288-5c6e-4ebf-a595-fe1be62d7dcc/images/7258187745023075bd89e44fe657a760835bb2c2d26f65e738954f24a01dbdb0.jpeg";
export const ABSTRACT_ORB = "https://static.prod-images.emergentagent.com/jobs/88abf288-5c6e-4ebf-a595-fe1be62d7dcc/images/f135e6fccb538d5348a68bd88f52a5fad1bca979d6a0325efb436f09370d1ce6.jpeg";
